"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalIdentityVersionConverter = void 0;
// tslint:disable:no-any
/**
 * This version converter doesn't actually do anything but is useful for testing or when we have
 * a matching platform and external version number
 */
class ExternalIdentityVersionConverter {
    downgradeExecuteCall(verb, parameters) {
        return {
            verb: verb,
            parameters: parameters,
        };
    }
    upgradeExecuteReturn(executeResponse, verb, parameters) {
        return executeResponse;
    }
    upgradeNotification(notification) {
        return notification;
    }
}
exports.ExternalIdentityVersionConverter = ExternalIdentityVersionConverter;
//# sourceMappingURL=ExternalIdentityVersionConverter.js.map